export const VERSION = 'dev-master#52e3525';
